import { useContext } from "react";
import {
  MusicContext,
  type MusicContextValue,
} from "@/lib/providers/music-context";

export function useMusic(): MusicContextValue {
  const context = useContext(MusicContext);
  if (!context) {
    throw new Error("useMusic must be used within a MusicProvider");
  }

  return context;
}
